import { DomainInitPayload, CardOnFile } from '@sxm-de/dev-kits/web-sdk/types';
import {
    getCardExpirationState,
    getDefaultPaymentMethod,
} from '../helpers/get-default-payment-method';

export type GetDefaultPaymentMethodCreditCardFn =
    () => Promise<CardOnFile | null>;

export function initGetDefaultPaymentMethodCreditCardFn({
    dependencies,
}: DomainInitPayload): GetDefaultPaymentMethodCreditCardFn {
    return async () => {
        const { card } = await getDefaultPaymentMethod(dependencies);

        if (card && !card.wallet?.applePay) {
            const expirationState = getCardExpirationState(
                card.expiryDate.year,
                card.expiryDate.month,
            );
            return {
                brand: card.brand,
                last4: card.last4,
                isExpired:
                    expirationState === 'EXPIRED' ||
                    expirationState === 'SOON_EXPIRED',
            };
        } else {
            return null;
        }
    };
}
